<script setup lang="ts">
import { useConfirm } from '@/composables/useConfirm'

const { visible, options, handleConfirm, handleCancel } = useConfirm()
</script>

<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition ease-out duration-150"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="visible"
        class="fixed inset-0 z-[90] flex items-center justify-center"
      >
        <div class="absolute inset-0 bg-black/50" @click="handleCancel"></div>
        <div class="relative bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 overflow-hidden">
          <div class="p-6">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">{{ options.title }}</h3>
            <p class="text-sm text-gray-600 dark:text-gray-300">{{ options.message }}</p>
          </div>
          <div class="px-6 py-4 bg-gray-50 dark:bg-gray-900/50 border-t border-gray-100 dark:border-gray-700 flex justify-end gap-3">
            <button
              @click="handleCancel"
              class="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 rounded-lg transition-colors"
            >
              {{ options.cancelText || 'Отмена' }}
            </button>
            <button
              @click="handleConfirm"
              class="px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors"
              :class="options.danger
                ? 'bg-negative-600 hover:bg-negative-700'
                : 'bg-primary-600 hover:bg-primary-700'"
            >
              {{ options.confirmText || 'Подтвердить' }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
